<!-- 周年特别礼 -->
<template>
  <div :class="$style['special-gift']">
    <h2>周年特别礼</h2>
    <icon-text
      :icon="specialGift.prizeIcon"
      :text="specialGift.prizeName"
      style="position: absolute; top: 0.8rem; left: 0.84rem"
    />
    <div :class="$style['special-gift-info']">
      <div :class="$style['special-gift-info-title']">{{ specialGift.title }}</div>
      <div :class="$style['special-gift-info-desc']">{{ specialGift.rule }}</div>
    </div>
    <!-- 立即领取 -->
    <button
      :disabled="teamMemberList && teamMemberList.length === 5"
      :class="[$style['btn-receive'], !isReceived && $style['btn-receive-failed']]"
      style="position: absolute; top: 1.06rem; right: 0.8rem"
      @click="handleReceive"
    />
    <!-- 邀请提示 -->
    <popup-frame ref="invite-tip" size="mini">
      <p style="padding-top: 0.2rem; font-size: 0.34rem; font-family: 'Source Han Serif SC Bold'">
        快快邀请回流团长加入队伍一起领好礼！
      </p>
      <p style="margin: 0.3rem 0.5rem; font-size: 0.24rem; line-height: 1.8">
        {{ specialGift.rule }}
      </p>
      <invite-link @copy-success="closeInviteTip">
        <template #trigger>
          <button :class="$style['btn-invite']" />
        </template>
      </invite-link>
    </popup-frame>
    <!-- 条件不满足提示 -->
    <popup-frame ref="condition-tip" size="mini">
      <p style="padding-top: 0.2rem; font-size: 0.34rem; font-family: 'Source Han Serif SC Bold'">
        很抱歉~您的队伍未达成领取条件
      </p>
      <p style="margin: 0.3rem 0.5rem; font-size: 0.24rem; line-height: 1.8">
        {{ specialGift.lotteryTip }}
      </p>
      <!-- 前往抽奖 -->
      <button :class="$style['btn-go-lottery']" @click="handleGoLottery" />
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IconText, PopupFrame } from '@/components/widgets'
import InviteLink from '../InviteLink'

export default {
  name: 'SpecialGift',
  components: {
    IconText,
    PopupFrame,
    InviteLink
  },
  computed: {
    ...mapGetters(['specialGift', 'isBindRole', 'teamMemberList', 'ownedGifts']),
    isReceived() {
      return this.ownedGifts.includes(278)
    }
  },
  methods: {
    handleReceive() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }

      // 未加入队伍，弹窗提示
      if (this.teamMemberList.length === 0) {
        this.$emit('no-team')
        return
      }

      // 队伍不满5人，弹窗提示
      if (this.teamMemberList.length !== 5) {
        this.$refs['invite-tip'].show()
        return
      }

      // 队伍已满5人，弹窗提示
      if (this.teamMemberList.length === 5) {
        this.$refs['condition-tip'].show()
        return
      }
    },
    closeInviteTip() {
      this.$refs['invite-tip'].hide()
    },
    handleGoLottery() {
      this.$refs['condition-tip'].hide()
      // 关闭弹窗后跳转到抽奖模块
      this.$emit('go-lottery')
    }
  }
}
</script>

<style lang="less" module>
.special-gift {
  position: relative;
  height: 3.35rem;

  h2 {
    padding-left: 1.4rem;
    font-size: 0.3rem;
    font-family: 'Source Han Serif SC Bold';
    line-height: 1.5;
    color: #fff;
  }

  &-info {
    position: absolute;
    top: 0.8rem;
    left: 2.18rem;
    width: 4.57rem;

    &-title {
      .size(100%, 1.16rem);
      .background-fill('./images/special-gift-info-bg.png');

      display: flex;
      align-items: center;
      padding-left: 0.2rem;
      line-height: 1.5;
      color: #f2f3ff;
    }

    &-desc {
      margin-top: 0.05rem;
      font-size: 0.16rem;
      line-height: 1.5;
      color: #4e56d3;
      text-align: center;
    }
  }
}

.btn-receive {
  .size(1.44rem, 0.54rem);
  .background-fill('./images/btn-receive.png', 100% 300%);

  &:disabled {
    background-position: 0 50%;
  }

  &-failed:disabled {
    background-position: 0 100%;
  }
}

.btn-invite {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-invite.png');
}

.btn-go-lottery {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-go-lottery.png');
}
</style>
